export enum Tenant {
  YSS = 'YSS',
  SRF = 'SRF'
}
